import { LearningItem } from '../../models/LearningItem'

export default function learningItemGroupAssignments(learningItem: LearningItem) {
  const groups = learningItem.groupLearningAssignments?.map((a) => a.group) || []

  const uniqueMap = new Map(groups.map((group) => [group!.uuid, group]))
  const uniqueGroups = Array.from(uniqueMap.values())

  uniqueGroups.sort((a, b) => {
    if (a!.name < b!.name) return -1
    if (a!.name > b!.name) return 1
    return 0
  })

  return uniqueGroups
}
